import React from "react";

import useDraftShoppingCart from "../../hooks/useDraftShoppingCart";

function CombinedPolicies(props) {
    const {draftShoppingCartItems} = useDraftShoppingCart()
    return (
        <ol>
            {draftShoppingCartItems.filter((item) => item.cartItemPoliciesText).map(({
                                                                                         featureId,
                                                                                         schemaId,
                                                                                         cartItemPoliciesText,
                                                                                         featureName
                                                                                     }, index) => (
                (
                    // eslint-disable-next-line react/no-array-index-key
                    <>
                        <li key={`${featureId}-${schemaId}-featureName`}>{featureName}</li>
                        <li key={`${featureId}-${schemaId}-featureText`}>{cartItemPoliciesText}</li>
                    </>
                )
            ))}
        </ol>
    )
}

export default CombinedPolicies